import React, { useEffect, useState, useMemo } from "react";
import axiosInstance from "../ReusableComponents/Axios";
import * as Yup from "yup";
const QBCList = (props) => {
  const [CList, SetCList] = useState();
  const [StoreCL, SetStoreCL] = useState();
  const [AQErrors, SetAQErrors] = useState({});
  const GetChecklist = async () => {
    const res = await axiosInstance.get(
      `/QuestionBank/GetQuestionChecklistQuestions?LanguageId=${props.LanguageId}`
    );
    SetCList(res.data);
    // const Storeids = res.data
    //   .map((item, index) => ({
    //     checklistQuestionId: parseInt(props.ExistingId?.split(",")?.[index]) || item.checklistQuestionId,
    //     status: parseInt(props.Existinvalues?.[index]) || 0,
    //   }));

    // const Storeids = res.data.map((item, index) => {
    //   const status = parseInt(props.Existinvalues?.[index]) ?? 0;

    //   return {
    //     checklistQuestionId: parseInt(props.ExistingId?.split(",")?.[index]) || item.checklistQuestionId,
    //     parentId: item.parentId, // assuming API has parentId
    //     status: status,
    //   };
    // });

    // // 👉 Group by parentId
    // const groupedByParent = Storeids.reduce((acc, curr) => {
    //   if (!acc[curr.parentId]) acc[curr.parentId] = [];
    //   acc[curr.parentId].push(curr);
    //   return acc;
    // }, {});

    // // 👉 Update parent status based on children
    // Object.keys(groupedByParent).forEach((parentId) => {
    //   const children = groupedByParent[parentId];

    //   const allOnes = children.every((child) => child.status === 1);

    //   // find parent in Storeids
    //   const parentIndex = Storeids.findIndex(
    //     (item) => item.checklistQuestionId === Number(parentId)
    //   );

    //   if (parentIndex !== -1) {
    //     Storeids[parentIndex].status = allOnes ? 1 : 0;
    //   }
    // });

     // 👉 Convert ExistingId + ExistingValues into a map
  const idArray = props.ExistingId?.split(",") || [];
  const valueArray = props.Existinvalues || [];

  const existingMap = {};

  idArray.forEach((id, i) => {
    existingMap[Number(id)] = Number(valueArray[i]) ?? 0;
  });

  // 👉 Build Storeids correctly using ID mapping
  const Storeids = res.data.map((item) => {
    return {
      checklistQuestionId: item.checklistQuestionId,
      parentId: item.parentId,
      status: existingMap[item.checklistQuestionId] ?? 0,
    };
  });
  // 👉 Group children by parentId
  const groupedByParent = Storeids.reduce((acc, curr) => {
    if (!acc[curr.parentId]) acc[curr.parentId] = [];
    acc[curr.parentId].push(curr);
    return acc;
  }, {});

  // 👉 Update parent based on children
  Object.keys(groupedByParent).forEach((parentId) => {
    const children = groupedByParent[parentId];

    const allOnes = children.every((child) => child.status === 1);

    const parentIndex = Storeids.findIndex(
      (item) => item.checklistQuestionId === Number(parentId)
    );

    if (parentIndex !== -1) {
      Storeids[parentIndex].status = allOnes ? 1 : 0;
    }
  });
    SetStoreCL(Storeids);
  };
  useEffect(() => {
    GetChecklist();
  }, [props.LanguageId]);

  const NON_MANDATORY_IDS = [9, 10, 11, 12, 13, 16, 17, 18, 19,23, 24, 25, 26, 27];
  const validationSchema = Yup.object().shape(
    StoreCL?.reduce((schema, item) => {
      const fieldKey = item.checklistQuestionId;
      // schema[fieldKey] = Yup.number()
      //     .oneOf([1], "This checklist item is required");
      if (!NON_MANDATORY_IDS.includes(fieldKey)) {
        schema[fieldKey] = Yup.number().oneOf(
          [1],
          "This checklist item is required"
        );
      }
      return schema;
    }, {})
  );
  const Validation = () => {
    props.RStoreHValidation(false);
    const formValues = StoreCL?.reduce((obj, item) => {
      const key = item.checklistQuestionId;
      obj[key] = item.status;
      return obj;
    }, {});
    validationSchema
      .validate(formValues, { abortEarly: false })
      .then(() => {
        props.GetValues(StoreCL);
        SetAQErrors({});
        props.VSuccess(true);
        props.CallValidation();
      })
      .catch((err) => {
        const newErrors = {};
        if (Array.isArray(err.inner)) {
          err.inner.forEach((error) => {
            newErrors[error.path] = error.message;
          });
        }
        // console.log("validation errors",newErrors)
        SetAQErrors(newErrors);
        props.VSuccess(false);
      });
  };
  // const StoreCheckList = (id, e) => {
  //   const status = e.target.checked ? 1 : 0;
  //   const Update = StoreCL.map((item) => item.checklistQuestionId === id ? { ...item, status } : item);
  //   SetStoreCL(Update);
  // };

  const StoreCheckList = (id, e) => {
    const status = e?.target?.checked ? 1 : 0;
    const currentItem = CList.find((item) => item.checklistQuestionId === id);
    const childIds = CList.filter((item) => item.parentId === currentItem.parentId).map((item) => item.checklistQuestionId);
    const allChildrenChecked = childIds.every((childId) => {
      if (childId === id) {
        return status === 1;
      } else {
        const childItem = StoreCL.find((item) => item.checklistQuestionId === childId);
        return childItem?.status === 1;
      }
    });
    const updatedList = StoreCL.map((item) => {
      if (item.checklistQuestionId === id) {
        return { ...item, status };
      } else if (item.checklistQuestionId === currentItem.parentId) {
        return { ...item, status: allChildrenChecked ? 1 : 0 };
      } else {
        return item;
      }
    });
    SetStoreCL(updatedList);
  };

  useMemo(() => {
    if (props.HValidation) {
      Validation();
    }
  }, [props.HValidation]);

  const MasterStoreCheckList = () => {
    const allChecked = StoreCL.every((item) => item.status === 1);
    const updatedList = StoreCL.map((item) => ({ ...item, status: allChecked ? 0 : 1 }));
    SetStoreCL(updatedList);
  }
  const PointLevelMSCL = (MId) => {
    const MItems = CList?.filter((item) => item?.parentId === MId || item?.checklistQuestionId === MId)
      .map(item => item.checklistQuestionId);
    const allChecked = StoreCL.filter(item => MItems.includes(item.checklistQuestionId))
      .every(item => item.status === 1);
    const updatedList = StoreCL.map(item =>
      MItems.includes(item.checklistQuestionId) ? { ...item, status: allChecked ? 0 : 1 } : item);
    SetStoreCL(updatedList);
  };
  return (
    <div className="mt-3">
      <b>Checklist for {props.Heading} Submission</b>
      <div className="dflex alignitems gap-2">
        <input type="checkbox" checked={StoreCL?.every((item) => item.status === 1)} onChange={(e) => MasterStoreCheckList()} />
        Select All Items </div>
      <ol>
        {CList?.filter((item) => item?.parentId === 0).map((MItem) => (
          <>
            <div className="dflex alignitems gap-4">< input type="checkbox" onChange={() => PointLevelMSCL(MItem?.checklistQuestionId)}
              checked={!!StoreCL?.filter((item) => item?.checklistQuestionId == MItem?.checklistQuestionId)?.[0]?.status}
            /><li>{MItem?.checklistQuestion}</li></div>
            <ul className="alpha-list">
              {CList.filter(
                (Sitem) => Sitem?.parentId === MItem?.checklistQuestionId
              ).map((SSitem) => (
                <>
                  <div className="dflex gap-4">
                    <input type="checkbox"
                      checked={
                        !!StoreCL?.filter(
                          (item) =>
                            item?.checklistQuestionId ==
                            SSitem?.checklistQuestionId
                        )?.[0]?.status
                      }
                      onChange={(e) => StoreCheckList(SSitem?.checklistQuestionId, e)}
                    />
                    <li>
                      {SSitem?.checklistQuestion}
                      {!NON_MANDATORY_IDS.includes(SSitem?.checklistQuestionId
                      ) && <span style={{ color: "red" }}> *</span>}
                    </li>
                  </div>
                  {AQErrors?.[SSitem?.checklistQuestionId] && (
                    <span className="error-message">
                      {AQErrors?.[SSitem?.checklistQuestionId]}
                    </span>
                  )}
                </>
              ))}
            </ul>
          </>
        ))}
      </ol>
    </div>
  );
};
export default QBCList;
